import React from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Figure,
  Form,
  Row,
} from "react-bootstrap";
import { sponsors } from "../../../components/shared/constraints";
const MemberDetail = () => {
  return (
    <div className="right-panel p-3">
      <div class="common-heading text-start mb-3">
        <h4 className="mb-3 fw-bold fs-5 ">Member Details </h4>
      </div>
    </div>
  );
};

export default MemberDetail;

// No of Members,no of volumnteers,no of Active user
